import { useTranslation } from "react-i18next";
import { Box, Chip, Typography } from "@mui/material";

import {
  CompletedJobsIcon,
  PreferredAgeIcon,
  ServiceDeliveryIcon,
  ServiceLocationIcon,
} from "../../assets/icons/go-hire-icons";

import { styles } from "./styles";

interface ServiceDetailsProps {
  completedJobs: number;
  isOnline: boolean;
  ageRange?: {
    minAge: number;
    maxAge: number;
  };
  serviceLocations?: Array<{ name: string }>;
}

export const ServiceDetails = ({ completedJobs, isOnline, ageRange, serviceLocations }: ServiceDetailsProps) => {
  const { t } = useTranslation("goService", { keyPrefix: "servicePage" });
  const firstLocation = serviceLocations?.[0];

  return (
    <>
      <Box sx={styles.serviceDetailsContainer}>
        <Typography sx={styles.serviceDetailsTitle}>
          <CompletedJobsIcon />
          {t("completedJobs")}
        </Typography>
        <Typography sx={styles.serviceDetailsValue}>{completedJobs}</Typography>
      </Box>
      <Box sx={styles.serviceDetailsContainer}>
        <Typography sx={styles.serviceDetailsTitle}>
          <ServiceDeliveryIcon />
          {t("serviceDelivery")}
        </Typography>
        <Typography sx={styles.serviceDetailsValue}>{isOnline ? t("online") : t("offline")}</Typography>
      </Box>
      <Box sx={styles.serviceDetailsContainer}>
        <Typography sx={styles.serviceDetailsTitle}>
          <PreferredAgeIcon />
          {t("preferredAge")}
        </Typography>
        <Typography sx={styles.serviceDetailsValue}>
          {t("fromTo", {
            from: ageRange?.minAge,
            to: ageRange?.maxAge,
          })}
        </Typography>
      </Box>
      <Box sx={styles.serviceDetailsContainer}>
        <Typography sx={styles.serviceDetailsTitle}>
          <ServiceLocationIcon />
          {t("serviceLocation")}
        </Typography>
        <Box sx={{ display: "flex", gap: "8px" }}>
          {firstLocation && (
            <Chip title={firstLocation.name} label={firstLocation.name} sx={styles.serviceDetailsChip} />
          )}
          {serviceLocations?.length && serviceLocations?.length > 1 && (
            <Chip
              title={`+${serviceLocations.length - 1}`}
              label={`+${serviceLocations.length - 1}`}
              sx={styles.serviceDetailsChip}
            />
          )}
        </Box>
      </Box>
    </>
  );
};
